import * as React from "react";
import type { SVGProps } from "react";
const SvgVueling = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 50 50"
    width="100%"
    height="100%"
    {...props}
  >
    <clipPath id="vueling_svg__a">
      <path d="M0 0h50v50H0z" />
    </clipPath>
    <g clipPath="url(#vueling_svg__a)">
      <path fill="#ffd300" d="M0 0h50v50H0z" />
      <path
        fill="#504f4f"
        d="m24.885 29.796-4.699-15.248a3.32 3.32 0 0 0-3.27-2.487A3.547 3.547 0 0 0 13 15.47c.017.7.174 1.388.46 2.026l6.081 16.768c1.198 3.27 2.257 4.377 5.344 4.377h.507c3.132 0 3.823-1.106 5.02-4.33l6.127-16.814c.283-.64.44-1.328.461-2.027a3.55 3.55 0 0 0-3.87-3.455 3.316 3.316 0 0 0-3.316 2.533l-4.607 15.478z"
      />
    </g>
  </svg>
);
export default SvgVueling;
